
import { audioEyeDomService } from '@/services/audioeye-dom.service';
import { accessibeDomService } from '@/services/accessibe-dom.service';
import { Attributes, PageAttributeType } from '@/entities/page.attributes';
import { configService } from '@/services/config.service';
import pageAttributesService from '@/services/page.attributes.service';
import storageService from '@/services/storage.service';
import { siteConfigService as siteConfigServiceUiCore } from '@ol/ol-ui-core';

interface AudioEyeConfig {
  enabled?: boolean;
  siteHash?: string;
}

interface EnabledAudioEyeConfig {
  siteHash: string;
}

class AccessibilityService {
  public async showAccessibityWidget(): Promise<void> {
    const environmentConfig = await configService.getConfigs();
    if (environmentConfig.showAccessibilityWidget !== 1) {
      return;
    }

    const audioEyeConfig = await this.getAudioEyeConfig();
    if (audioEyeConfig) {
      audioEyeDomService.addWidgetScript(audioEyeConfig.siteHash);
      return;
    }

    const plConfig: Attributes = await pageAttributesService.getPageAttributeByTypeId(PageAttributeType.PAGE_ELEMENT_SECTION_CONFIG_TYPE);
    // eslint-disable-next-line
    const isEnabledInProgram = plConfig.attributes['SHOW_ACCESSIBILITY_WIDGET_FOR_ALL_PAGES'] === '1';

    if (isEnabledInProgram) {
      accessibeDomService.addWidgetScript();
    }
  }

  public async isAudioEyeEnabled(): Promise<boolean> {
    return !!(await this.getAudioEyeConfig());
  }

  private async getAudioEyeConfig(): Promise<EnabledAudioEyeConfig | null> {
    const plId = await storageService.getPrivateLabelId();
    const siteInfo = await siteConfigServiceUiCore.getSiteInfo(plId);
    const audioEyeConfig: AudioEyeConfig = siteInfo?.privateLabelInfo?.additionalInfo?.accessibility?.audioEye || {};

    if (audioEyeConfig.enabled === true && !audioEyeConfig.siteHash) {
      throw new Error('AudioEye is enabled, but no Site Hash is configured.');
    }

    return audioEyeConfig.enabled === true && !!audioEyeConfig.siteHash ? { siteHash: audioEyeConfig.siteHash } : null;
  }
}
export const accessibilityService = new AccessibilityService();
